import React from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import TextField from '@mui/material/TextField';
export const FormTextField = ({
	name,
	control,
	label,
	rules,
	helperText,
	type,
	autocomplete,
	multiline,
	rows,
	onBlur,
	inputProps,
	size,
	maxLen,
	showCharacterLimit,
	readOnly,
	numeric,
	dataTestId,
	placeholder,
	thousandSeparator
}: {
	name: string;
	control: Control<any, any>;
	label: string;
	rules?: Record<string, unknown>;
	helperText?: string;
	type?: string;
	autocomplete?: string;
	multiline?: boolean;
	rows?: number;
	size?: string;
	maxLen?: number;
	inputProps?: any;
	onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	showCharacterLimit?: boolean;
	readOnly?: boolean;
	numeric?: boolean;
	dataTestId?: string;
	placeholder?: string;
	thousandSeparator?: boolean;
}) => {
	const getHelperText = (value: any, error?: FieldError) => {
		let message = '';
		const maxLength = rules?.maxLength as { value: number } | number;
		if (showCharacterLimit && maxLength) {
			message += `${value.length ?? 0}/${typeof maxLength === 'object' ? maxLength.value : maxLength} `;
		}
		if (error?.message) {
			message += error.message;
		} else {
			message += helperText ?? '';
		}

		return message;
	};

	const handleStopSwipe = (e: { stopPropagation: () => void }) => {
		e.stopPropagation();
	};

	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				const displayValue = thousandSeparator && value
					? Number(String(value).replace(/,/g, '')).toLocaleString('en-US')
					: value;

				const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
					if (thousandSeparator) {
						const raw = e.target.value.replace(/,/g, '');
						onChange(raw);
					} else {
						onChange(e);
					}
				};

				return (
					<TextField
						onMouseDown={handleStopSwipe}
						onTouchStart={handleStopSwipe}
						helperText={getHelperText(value, error)}
						size={size === 'small' || size === 'medium' ? size : 'small'}
						error={!!error}
						onChange={handleChange}
						onBlur={onBlur}
						value={displayValue}
						fullWidth
						label={label}
						variant="outlined"
						type={type}
						onInput={(e) => {
							const input = e.target as HTMLInputElement;
							if (numeric || thousandSeparator) {
								input.value = input.value.replace(/[^0-9,]/g, '');
							}
							if (maxLen && input.value.replace(/,/g, '').length > maxLen) {
								input.value = input.value.slice(0, maxLen);
							}
						}}
						autoComplete={autocomplete}
						multiline={multiline}
						rows={rows}
						placeholder={placeholder}
						InputProps={{
							autoComplete: 'off',
							readOnly: readOnly,
							disabled: readOnly,
							...inputProps
						}}
						inputProps={{
							'data-testid': dataTestId
						}}
					/>
				);
			}}
		/>
	);
};
